import React, { FC, useEffect } from 'react';

import { DiffWordItem } from './diff-word-item/DiffWordItem';
import styles from './diff-words.module.scss';
import { getUserId } from '../../../Login/helpers/storage';
import { useActions } from '../../../../hooks/useAction';
import { useTypedSelector } from '../../../../hooks/useTypesSelector';
import { Loading } from '../../../../ui/loading/Loading';

interface props {
  group: number;
}
export const DiffWords: FC<props> = ({ group }) => {
  const userId = getUserId() || '';
  const { fetchAllDiffWords } = useActions();
  const { diffWords, diffWordsEmpty, loading } = useTypedSelector((state) => state.userWords);
  const unit = 0;

  useEffect(() => {
    if (loading || diffWordsEmpty) return;
    if (diffWords.length === 0) {
      fetchAllDiffWords(userId);
    }
  }, [diffWords, diffWordsEmpty, fetchAllDiffWords, loading, userId, group]);

  if (loading && diffWords.length === 0) {
    return (
      <>
        <Loading />
      </>
    );
  }

  if (diffWordsEmpty) return <h1>В данном разделе пока нет слов</h1>;

  return (
    <div className={styles.wrapper}>
      {diffWords.map((word) => (
        <DiffWordItem key={word._id} words={word} userWords={word.userWord} />
      ))}
    </div>
  );
};
